import { render } from "./loading-dots.vue?vue&type=template&id=9d3d03c4&scoped=true&lang=pug"
import script from "./loading-dots.vue?vue&type=script&lang=js"
export * from "./loading-dots.vue?vue&type=script&lang=js"

import "./loading-dots.vue?vue&type=style&index=0&id=9d3d03c4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d3d03c4"]])

export default __exports__